export const checkRegExp = (value, type) => {
  switch (type) {
    case "url":
      return value
        .match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{1,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
  }
};
